export const ANNOTATION_LANGUAGE = 'aurum.com.br/language';
export const ANNOTATION_FRAMEWORK = 'aurum.com.br/framework';
export const ANNOTATION_RUNTIME = 'aurum.com.br/runtime';
export const ANNOTATION_PLATFORM = 'aurum.com.br/platform';
export const ANNOTATION_TECHNOLOGY = 'aurum.com.br/technology';
export const ANNOTATION_GCP_PROJECT = 'aurum.com.br/gcp-project';

export const C4_STACK_ANNOTATIONS = [
  ANNOTATION_LANGUAGE,
  ANNOTATION_FRAMEWORK,
  ANNOTATION_RUNTIME,
  ANNOTATION_PLATFORM,
  ANNOTATION_TECHNOLOGY,
] as const;

export type C4StackAnnotation = (typeof C4_STACK_ANNOTATIONS)[number];

export function getAnnotation(
  entity: { metadata?: { annotations?: Record<string, string> } },
  annotation: string,
): string | undefined {
  const value = entity?.metadata?.annotations?.[annotation];
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}
